/**
 * Service: formApi
 */
angular.module('acme.common.service.formApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('FormApiService', ['$http', '$q', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, $q, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/forms';
        this.responses.service = this.service + '/responses';
        this.states.service = endpoint + '/locations/states';
        this.countries.service = endpoint + '/locations/countries';
        this.avs.service = endpoint + '/locations/avs/countries';
        this.customFields.service = this.service + '/customfields';
        return this;
      },

      list: function(props) {
        var q = '';
        var av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['published'],
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search', 'formCategoryType']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });
      },

      detail: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
        });
      },

      published: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/' + props.id + '/contentfrompublished', version: 'v2' })
        });
      },

      create: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'post',
          url: av.init({ url: this.service, version: 'v2' }),
          data: {
            name: props.name,
            description: props.description,
            type: props.type,
            source: props.source,
            sourceFormId: props.id,
            sourceFormUrl: props.sourceFormUrl,
            sourceFormEditUrl: props.sourceFormEditUrl,
            sourceFormThumbnail: props.sourceFormThumbnail,
            sourceFormDefinition: props.sourceFormDefinition,
            state: props.state,
            lastUpdatedDate: props.lastUpdatedDate,
            lastPublishedDate: props.lastPublishedDate,
            oncePerCart: props.oncePerCart,
            formCategoryType: props.formCategoryType,
            formDisplaySettings: props.formDisplaySettings
          }
        });
      },

      update: function(props, publish) {
        var av = new ApiVersionFactory();
        var q = '';

        if (publish) {
          q += '?publish=true';
        }

        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/' + props.id + q, version: 'v2' }),
          data: {
            id: props.id,
            name: props.name,
            description: props.description,
            type: props.type,
            source: props.source,
            sourceFormId: props.id,
            sourceFormUrl: props.sourceFormUrl,
            sourceFormEditUrl: props.sourceFormEditUrl,
            sourceFormThumbnail: props.sourceFormThumbnail,
            sourceFormDefinition: props.sourceFormDefinition,
            state: props.state,
            lastUpdatedDate: props.lastUpdatedDate,
            lastPublishedDate: props.lastPublishedDate,
            oncePerCart: props.oncePerCart,
            formCategoryType: props.formCategoryType,
            formDisplaySettings: props.formDisplaySettings
          }
        });
      },
      
      remove: function(id) {
        var  av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({ url: this.service + '/' + id, version: 'v2' })
        }); 
      },
                  
      responses: {
        
        service: '',

        list: function(props) {
          var q = '';
          var av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + q, version: 'v2' })
          });
        },

        detail: function(props) {
          var av = new ApiVersionFactory();
          
          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              formId: props.formId,
              name: props.name,
              type: props.type,
              source: props.source,
              number: props.number,
              sourceFormId: props.sourceFormId,
              sourceFormResponseId: props.sourceFormResponseId,
              sourceFormUploads: props.sourceFormUploads,
              customFormFields: props.customFormFields,
              responseData: props.responseData,
              submissionDate: props.submissionDate
            }
          });
        },

        update: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: this.service + '/' + props.id, version: 'v2'}),
            data: {
              id: props.id,
              formId: props.formId,
              number: props.number,
              name: props.name,
              type: props.type,
              source: props.source,
              customFields: props.customFields,
              responseData: props.responseData,
              submissionDate: props.submissionDate
            }
          });
        },
        
        delete: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
          });
        }

      },

      states: {

        service: '',

        list: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service + '/' + props.country, version: 'v2' })
          });
        }

      },

      countries: {

        service: '',

        list: function() {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service, version: 'v2' })
          });
        }

      },

      avs: {

        service: '',

        countries: function () {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({ url: this.service, version: 'v2' })
          });

        }

      },

      customFields: {
        service: '',

        list: function(props) {
          var av = new ApiVersionFactory();
          var q = '';

          if(props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: (this.service + q), version: 'v2'})
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({url: this.service, version: 'v2'}),
            data: props
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: this.service, version: 'v2'}),
            data: props
          });
        },

        remove: function(id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({url: (this.service + '/' + id), version: 'v2'})
          });
        }

      }

    };

}]);